export default __webpack_public_path__ + "static/media/nodejs-logo-FBE122E377-seeklogo.com.8e341cc0.png";